import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"font-weight":"500"} }
const _hoisted_2 = ["innerHTML"]

import { extraStore } from '@/stores/v2/extra'
import WoononExtraProductMobile from '@/components/v2/extra/WoononExtraProductMobile.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'WoononExtraProductsMobile',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!

  return (_openBlock(), _createBlock(_component_a_collapse, { class: "extra-collapse" }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(extraStore)().elements, (element) => {
        return (_openBlock(), _createBlock(_component_a_collapse_panel, {
          class: "extra-collapse-panel",
          key: element.id
        }, {
          header: _withCtx(() => [
            _createElementVNode("span", _hoisted_1, _toDisplayString(element.commercial_name), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_row, {
              gutter: [16,16],
              class: "no-mb"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    (element.commercial_description)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "mb-16",
                          innerHTML: element.commercial_description
                        }, null, 8, _hoisted_2))
                      : _createCommentVNode("", true),
                    _createVNode(_component_a_row, {
                      gutter: [16,16],
                      class: "no-mb"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(element.products, (product) => {
                          return (_openBlock(), _createBlock(_component_a_col, {
                            span: 24,
                            key: product.id
                          }, {
                            default: _withCtx(() => [
                              _createVNode(WoononExtraProductMobile, {
                                store: _unref(extraStore)(),
                                product: product,
                                isConfigurable: element.is_configurable_by_customer
                              }, null, 8, ["store", "product", "isConfigurable"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }))
}
}

})